import { NgClass} from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink} from '@angular/router';
import { MenuItem, PrimeTemplate } from 'primeng/api';
import { Breadcrumb } from 'primeng/breadcrumb';
import { Button } from 'primeng/button';
import { Card } from 'primeng/card';
import { ErrorCode } from '../../../core/enums/error-code';
import { AuthService } from '../../../core/services/auth.service';
import { ErrorProviderService } from '../../../core/services/error-provider.service';
import { I18nService } from '../../../core/services/i18n.service';
import { RuntimeConfigService } from '../../../core/services/runtime-config.service';
import { SpsSupportInfoComponent } from '../../../custom/components/sps-support-info/sps-support-info.component';


@Component({
  selector: 'app-error-page',
  imports: [
    RouterLink,
    Breadcrumb,
    NgClass,
    Card,
    PrimeTemplate,
    Button,
    SpsSupportInfoComponent
  ],
  templateUrl: './error-page.component.html',
})
export class ErrorPageComponent implements OnInit {

  i18n = inject(I18nService);
  errorProvider = inject(ErrorProviderService);
  authService = inject(AuthService);
  runtimeConfig = inject(RuntimeConfigService);
  private route = inject(ActivatedRoute);
  protected errorType: string = '';

  /**
   * extrnal link URL's
   */
  imprintUrl: string = this.runtimeConfig.spsImprintUrl;
  agbUrl: string = this.runtimeConfig.spsAGBUrl;
  privacyUrl: string = this.runtimeConfig.spsPrivacyUrl;

  /**
   * Info-Breadcrumb-Item for specific error
   */
  breadcrumbItems: MenuItem[] | null = null;

  /**
   * Links to the API-Reference and the User Manual
   */
  apiUrl: string = this.runtimeConfig.apiReferenceLink;
  manualUrl: string = this.runtimeConfig.userManualLink;


  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      if (params && (params.get('errortype') !== null)) {
        this.errorType = params.get('errortype');
      }
      if (!this.errorType) {
        this.errorType = 'logout';
      }
      switch (this.errorType) {
        case 'auth':
        case 'permission':
          this.breadcrumbItems = [{
            label: 'Info',
            icon: 'pi pi-info-circle',
          }];
          break;
        case 'logout':
          this.breadcrumbItems = [{
            label: 'Logout',
            icon: 'pi pi-sign-out',
          }];
          break;
        default:
          this.breadcrumbItems = [{
            label: this.i18n.i18nLng()['HTTPDATAERROR'],
            icon: 'pi pi-exclamation-triangle',
          }];
          break;
      }
    });
  }

  protected readonly ErrorCode = ErrorCode;
}
